var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('FormWizard'),(_vm.isSandbox)?_c('div',{staticClass:"alert alert-warning mt-5"},[_vm._v("\n        sandbox enabled: Aplikace nebude zapisovat do databáze.\n    ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }